import { Card } from '../ui/Card';
import { Star, ShieldCheck } from 'lucide-react'; // Using ShieldCheck for financial rating
import { useCurrency } from '../../hooks/useCurrency';

interface KeyPerformanceIndicatorsCardProps {
  creditScore: number;
  financialRating: string;
}

export function KeyPerformanceIndicatorsCard({
  creditScore,
  financialRating,
}: KeyPerformanceIndicatorsCardProps) {
  const { currentCurrency } = useCurrency();
  
  // Determine credit score remark based on scale 0-100
  let creditScoreRemark = 'Moyenne';
  let creditScoreColor = 'text-yellow-600';
  
  if (creditScore >= 80) {
    creditScoreRemark = 'Excellente';
    creditScoreColor = 'text-green-600';
  } else if (creditScore >= 65) {
    creditScoreRemark = 'Bonne';
    creditScoreColor = 'text-blue-600';
  } else if (creditScore >= 50) {
    creditScoreRemark = 'Moyenne';
    creditScoreColor = 'text-yellow-600';
  } else {
    creditScoreRemark = 'Faible';
    creditScoreColor = 'text-red-600';
  }

  return (
    <Card title="Indicateurs de Performance Clés" className="h-fit">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div className="space-y-2 p-3 bg-gray-50 dark:bg-gray-800/50 rounded-lg border border-gray-100 dark:border-gray-700">
          <div className="flex items-center text-primary">
            <Star className="h-4 w-4 mr-2 flex-shrink-0 text-amber-500" />
            <h3 className="text-xs font-medium text-gray-700 dark:text-gray-300">Cote de Crédit</h3>
          </div>
          <div className="flex items-baseline space-x-2">
            <p className="text-lg font-bold text-gray-900 dark:text-white">{creditScore}</p>
            <span className="text-sm text-gray-500">/100</span>
          </div>
          <p className={`text-xs ${creditScoreColor}`}>{creditScoreRemark} solvabilité</p>
        </div>

        <div className="space-y-2 p-3 bg-gray-50 dark:bg-gray-800/50 rounded-lg border border-gray-100 dark:border-gray-700">
          <div className="flex items-center text-primary">
            <ShieldCheck className="h-4 w-4 mr-2 flex-shrink-0 text-emerald-500" />
            <h3 className="text-xs font-medium text-gray-700 dark:text-gray-300">Note Financière</h3>
          </div>
          <p className="text-lg font-bold text-gray-900 dark:text-white">{financialRating}</p>
          <p className="text-xs text-gray-500">Perspective ({currentCurrency})</p>
        </div>
      </div>
    </Card>
  );
}
